var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 19.25C7.72136 19.25 5.86046 18.6855 4.27764 17.6279C2.69482 16.5703 1.46116 15.0671 0.732664 13.3083C0.00417035 11.5496 -0.186437 9.61433 0.184946 7.74726C0.556329 5.88019 1.47302 4.16518 2.8191 2.8191C4.16518 1.47302 5.88019 0.556329 7.74726 0.184946C9.61433 -0.186437 11.5496 0.00417035 13.3083 0.732664C15.0671 1.46116 16.5703 2.69482 17.6279 4.27764C18.6855 5.86046 19.25 7.72136 19.25 9.625C19.25 12.1777 18.2359 14.6259 16.4309 16.4309C14.6259 18.2359 12.1777 19.25 9.625 19.25ZM9.625 1.375C7.99331 1.375 6.39826 1.85886 5.04155 2.76538C3.68484 3.6719 2.62742 4.96038 2.003 6.46787C1.37858 7.97536 1.2152 9.63416 1.53353 11.2345C1.85185 12.8348 2.63759 14.3049 3.79137 15.4586C4.94516 16.6124 6.41517 17.3982 8.01551 17.7165C9.61585 18.0348 11.2747 17.8714 12.7821 17.247C14.2896 16.6226 15.5781 15.5652 16.4846 14.2085C17.3911 12.8518 17.875 11.2567 17.875 9.625C17.875 7.43697 17.0058 5.33855 15.4586 3.79137C13.9115 2.2442 11.813 1.375 9.625 1.375Z",
    fill: "#9D9FA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7806 13.75L8.9375 9.90687V3.4375H10.3125V9.33625L13.75 12.7806L12.7806 13.75Z",
    fill: "#9D9FA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloak);
export default __webpack_public_path__ + "static/media/cloak.8dd243cf54ce9808daf71de05d8ce87e.svg";
export { ForwardRef as ReactComponent };